<template>
  <div>
    <v-sheet
      color="white"
      class="px-4 py-3 mb-4"
    >
      <v-alert
        v-if="item.inflowStatusCode === 'V'"
        outlined
        type="error"
      >
        {{ $t('eDocInternal.canceledByAdmin') }}
      </v-alert>
      <div class="d-flex">
        <div class="flex-grow-1">
          <h3>{{ item.senderCode?item.senderCode:item.caseId }} {{ item.subject }}</h3>
          <div class="text-body-2">
            <span class="mr-4 grey--text">{{ $t('eDocInternal.sendDocEntity') }}：{{ $chPtObjData('chinSenderEntityName', item) }}</span>
            <!-- <v-chip
              color="red"
              outlined
              small
            >
              $緊急
            </v-chip> -->
          </div>
        </div>
        <s-class-pdf-muti
          v-model="dialog"
          :file-ctxs="files"
        />
        <s-view-doc-btn-by-date
          :receiver-info="receiverInfo"
          @previewFile="prepareFileList($event)"
        />

        <s-download-batch-doc-btn
          v-if="$config.isBrowser"
          :loading="downloadBatchDocLoading"
          :receiver-info="receiverInfo"
          @downloadBatch="downloadBatchDocument($event)"
        />
        <!-- <v-btn
          v-if="receiverInfo"
          icon
          large
          :loading="downloadBatchDocLoading"
          @click="downloadBatchDocument(receiverInfo.receiverProcessIds)"
        >
          <v-icon color="deep-orange lighten-2">
            {{ mdiDownload }}
          </v-icon>
        </v-btn> -->
      </div>
      <div>
        <div
          v-if="receiverInfo && receiverInfo.length"
          class="mb-4 text-body-2"
        >
          {{ $t('eDocInternal.docDetail.receiver') }}:
          <div
            v-for="receiver in receiverInfo"
            :key="receiver.receiverProcessIds"
          >
            {{ showGroupedReceiverAndGroupName(receiver) }}
            ({{ momentWithHyphen(receiver.processCreatedTime).format('YYYY-MM-DD HH:mm') }})
          </div>
        </div>
      </div>

      <v-divider />

      <br>

      <template v-if="item.statusCode !== DOC_FLOW_STATUS.CLOSED">
        <s-flow-viewer
          :process-id="item.dfProcessId"
        />
        <br><br>
      </template>

      <div class="text-body-2 grey--text mb-4">
        {{ $t('eDocSuggest.myOpinion') }}
      </div>

      <v-alert
        v-if="item.statusCode === DOC_FLOW_STATUS.CLOSED"
        class="mb-8"
        text
        color="deep-orange"
        type="success"
      >
        {{ $t('eDocInternal.alreadyMarkAsCompleted') }}
      </v-alert>
      <div
        v-if="item.statusCode === DOC_FLOW_STATUS.CLOSED"
        class="text-body-2 grey--text mb-4"
      >
        {{ $t('eDocInternal.reply.lastStaff') }}: {{ $chPtObjData('chinModifiedName', item) }}
      </div>

      <!-- <s-instruction-and-more
        :instruction="item.senderInstruction"
        :prefill-info="prevPrefillInfo"
        :sender-note="item.senderNote"
        :sender-name="$chPtObjData('chinSenderName',item)"
      /> -->
      <div
        v-for="(rec, i) in receiverInfo"
        :key="rec.id"
      >
        <div class="d-flex text-body-2">
          <span v-if="receiverInfo.length > 1">{{ i + 1 }}</span>
          <v-spacer />
          <span class="grey--text">{{ momentWithHyphen(rec.processCreatedTime).format('YYYY-MM-DD HH:mm') }}</span>
        </div>
        <s-instruction-and-more
          :instruction="rec.senderInstruction"
          :prefill-info="rec.prefilledInstruction"
          :sender-note="rec.senderNote"
          :sender-name="$chPtObjData('chinSenderName',rec)"
        />
      </div>

      <!-- <v-alert
        v-if="receiverInfo && receiverInfo.length"
        border="left"
        colored-border
        color="red"
        class="text-body-2 grey lighten-4 pl-5"
      >
        <div class="font-weight-bold">
          {{ $t('DocFlow.Instruction') }}：
        </div>
        <span
          v-for="rec in receiverInfo"
          :key="`ins${rec.receiverProcessIds}`"
        >{{ rec.senderInstruction }} ({{ momentWithHyphen(rec.processCreatedTime).format('YYYY-MM-DD HH:mm') }})<br></span>
      </v-alert> -->

      <br>

      <v-divider />
      <br>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="text-body-2 grey--text">
              {{ $t('eDocSuggest.receiverContent') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <s-message-header
              :doc="item"
            />
            <!--
            <div class="d-flex flex-wrap align-center mb-4 text-body-2">
              <div>$寄件者: 王三十</div>
              <v-spacer />
              <div class="text-caption grey--text">
                2020-11-8 9:41
              </div>
            </div> -->

            <br>

            <s-e-doc-provider-json-de :task="item" />

            <s-ancestor-process :process-id="item.dfProcessId" />

            <s-encrypted-viewer-staff
              v-if="item.securityLevelId && item.securityLevelId > 1"
              :opener-list="openerList"
              :security-level-id="item.securityLevelId"
            />

            <!--    <v-dialog
              v-model="fullHistoryDialog"
              scrollable
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  depressed
                  v-bind="attrs"
                  class="mb-2"
                  v-on="on"
                  @click="getAncestorProcess(item.dfProcessId, inflowStatus)"
                >
                  {{ $t('eDocInternal.viewInstructionRecord') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>{{ $t('eDocInternal.sentReceiveInstructionRecord') }}</v-card-title>
                <v-divider />
                <div class="pa-2">
                  <v-simple-table>
                    <tbody>
                      <tr
                        v-for="proc in ancestorProcess"
                        :key="`ancestor${proc.id}`"
                      >
                        <td class="pr-0">
                          {{ momentWithHyphen(proc.createdTime).format('YYYY-MM-DD HH:mm') }}
                        </td>
                        <td
                          class="pr-0"
                          style="min-width: 80px;"
                        >
                          {{ $chPtObjData('chinSenderName', proc) }}
                        </td>
                        <td class="pr-0">
                          {{ proc.senderInstruction }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    text
                    @click="fullHistoryDialog = false"
                  >
                    {{ $t('PublicServant.Action.Close') }}
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    :loading="genPdfBtnLoading"
                    depressed
                    @click="getInstructionPdf(item.dfProcessId, inflowStatus)"
                  >
                    {{ $t('eDocInternal.createInstructionRecord') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

            <s-instruction-and-more
              :instruction="item.senderInstruction"
              :prefill-info="prevPrefillInfo"
              :sender-note="item.senderNote"
              :sender-name="$chPtObjData('chinSenderName',item)"
            />

            <!-- <v-alert
              border="left"
              colored-border
              color="red"
              class="text-body-2 grey lighten-4 pl-5"
            >
              <div class="font-weight-bold">
                {{ $chPtObjData('chinSenderName',item) }} {{ $t('eDocSuggest.instructionOf') }}：
              </div>
              {{ item.senderInstruction }}
            </v-alert>

            <v-alert
              border="left"
              colored-border
              color="light-blue"
              class="text-body-2 grey lighten-4 pl-5"
            >
              <div class="font-weight-bold">
                #{{ $t('eDocInternal.notFinish') }} {{ $chPtObjData('chinSenderName',item) }}  {{ $t('eDocInternal.handleMethodSuggestion') }}
              </div>
            </v-alert>

            <v-alert
              v-if="item.senderNote"
              border="left"
              colored-border
              color="yellow"
              class="text-body-2 grey lighten-4 pl-5"
            >
              <div class="font-weight-bold">
                {{ $chPtObjData('chinSenderName',item) }}{{ $t('eDocSuggest.privateMsgToMe') }}：
              </div>
              {{ item.senderNote }}
            </v-alert> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="text-body-2 grey--text">
              {{ $t('eDocInternal.archiveDoc.related') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div v-if="!childArchivedDocList || !childArchivedDocList.length">
                {{ $t('PublicServant.NoData') }}
              </div>
              <div
                v-else
                class="mx-n3"
              >
                <v-simple-table>
                  <thead>
                    <tr>
                      <th>{{ $t('eDocInternal.archiveDoc.doc') }}</th>
                      <th>{{ $t('eDocInternal.archiveDoc.type') }}</th>
                      <th>{{ $t('PublicServant.Staff') }}</th>
                      <th>{{ $t('PublicServant.Obser') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="doc in childArchivedDocList"
                      :key="doc.id"
                    >
                      <td>
                        <a @click="downloadArchiveFile(doc)">{{ doc.docName }}</a>
                      </td>
                      <td>
                        {{ $chPtObjData('chinName', archiveDocType[doc.dfArchiveDocTypeId - 1]) }}
                      </td>
                      <td>
                        {{ $chPtObjData('creatorChinName', doc) }}
                        <br>
                        {{ momentWithHyphen(doc.createdTime).format('YYYY-MM-DD HH:mm') }}
                      </td>
                      <td>
                        {{ doc.remark }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div
        v-if="!isShowSendToNextCard && item.inflowStatusCode !== 'V'"
        class="d-flex mt-4"
      >
        <v-spacer />
        <s-int-receiver-list
          v-if="item.statusCode !== DOC_FLOW_STATUS.CLOSED"
          :process-id="item.dfProcessId"
          @refreshReceiverInfo="getProcessReceiverInfo"
        />
        <!-- <v-btn
            icon
            color="light-blue"
            class="mr-2"
          >
            <v-icon>
              {{ mdiRedo }}
            </v-icon>
             轉交
          </v-btn> -->
        <!-- 轉交-->
        <s-transfer-process
          css-class="mr-2"
          :edoc="item"
          :doc-flow-status="status"
          :upload-file-url="uploadFileUrl"
          @back="closeCardAndBack"
        />
        <!-- <s-transfer-process
          css-class="mr-2"
          :require-message="requireMessage"
          @transfer-process="transferProcessToStaff(item.dfProcessId, $event)"
        /> -->

        <!-- <s-archive-process
          :process-id="item.dfProcessId"
          :doc-flow-status="status"
        /> -->

        <!-- 處理 -->
        <v-tooltip
          color="black"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!canOnlyTransfer"
              icon
              color="primary"
              class="v-btn--outlined-bold"
              v-bind="attrs"
              v-on="on"
              @click="showAndPrepareFileList()"
            >
              <v-icon>
                {{ mdiFountainPenTip }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DocFlow.Instruction') }} / {{ $t('DocFlow.Instruction.B') }}</span>
        </v-tooltip>
      </div>

      <v-sheet
        v-if="isShowSendToNextCard"
        elevation="6"
        rounded
        class="mt-10 mx-n4 mb-n3 pb-4"
      >
        <v-toolbar
          dense
          flat
        >
          <v-toolbar-title class="text--body-1 mt-3">
            {{ $t('eDocInternal.handle') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            class="mt-2"
            @click="isShowSendToNextCard = false"
          >
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-3">
          <s-to-next-content
            :edoc="item"
            :upload-file-url="uploadFileUrl"
            :doc-flow-status="status"
            @closeCard="closeCardAndBack"
          />
          <!-- <div class="d-flex">
                <v-spacer />
                <v-btn
                  class="primary"
                  @click="forward"
                >
                  送出
                </v-btn>
              </div> -->
        </div>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiArrowLeft, mdiRedo, mdiSend, mdiInformationOutline, mdiPencil, mdiClose, mdiFileCheckOutline, mdiFountainPenTip, mdiCheckboxMarkedCircle, mdiDownload } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { DOC_FLOW_STATUS, TASK_LIST_JOB_TYPE } from '@/constant/constant'

import SFlowViewer from './SFlowViewer'
import SMessageHeader from '../eDocInternal/SMessageHeader'
import STransferProcess from '../eDocInternal/STransferProcess'
import SToNextContent from '../eDocInternal/SToNextContent'
import SClassPdfMuti from '@/components/SClassPdfMuti'
// import SViewDocBtn from '../eDocInternal/SViewDocBtn.vue'
import SViewDocBtnByDate from '../eDocInternal/SViewDocBtnByDate'
import SInstructionAndMore from '../eDocInternal/SInstructionAndMore'
import SEDocProviderJsonDe from '../eDocInternal/SEDocProviderJsonDe'
import SIntReceiverList from '../eDocInternalHistory/SIntReceiverList'
import SAncestorProcess from '../eDocInternal/SAncestorProcess'
import SDownloadBatchDocBtn from '../eDocInternal/SDownloadBatchDocBtn.vue'
import SEncryptedViewerStaff from '../eDocInternal/SEncryptedViewerStaff.vue'

// import SSearchStaff from '@/components/SSearchStaff'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { globalModule, docFlowModule } from '@/store/moduleName'
import { mapState } from 'vuex'

export default {
  components: {
    // SSearchStaff,
    SMessageHeader,
    SFlowViewer,
    STransferProcess,
    SToNextContent,
    SClassPdfMuti,
    SViewDocBtnByDate,
    SInstructionAndMore,
    SEDocProviderJsonDe,
    SIntReceiverList,
    SAncestorProcess,
    SDownloadBatchDocBtn,
    SEncryptedViewerStaff
  },
  mixins: [docFlowMethod],
  props: {
    item: { // edoc
      type: Object,
      default: null
    },
    canOnlyTransfer: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      mdiRedo: mdiRedo,
      mdiSend: mdiSend,
      mdiInformationOutline: mdiInformationOutline,
      mdiPencil: mdiPencil,
      mdiClose: mdiClose,
      mdiFountainPenTip,
      mdiFileCheckOutline: mdiFileCheckOutline,
      mdiCheckboxMarkedCircle: mdiCheckboxMarkedCircle,
      mdiDownload: mdiDownload,
      // pdfDialog: false,
      dialog: false,
      fullHistoryDialog: false,
      maskAsCompleteDialog: false,
      ancestorProcess: [],
      isShowSendToNextCard: false,
      files: [],
      uploadFileUrl: null,
      status: [DOC_FLOW_STATUS.PROCESSED, DOC_FLOW_STATUS.CLOSED, DOC_FLOW_STATUS.REDIRECTED],
      receiverInfo: [],
      prevPrefillInfo: null,
      DOC_FLOW_STATUS,
      TASK_LIST_JOB_TYPE,
      childArchivedDocList: [],
      archiveDocType: [],
      downloadBatchDocLoading: false
    }
  },
  computed: {
    ...mapState(docFlowModule, {
      taskListJobType: state => state.tasklistJobType,
      inflowStatus: state => state.inflowStatus
      // redirectPath: state => state.redirectPath
    })
  },
  async created () {
    this.uploadFileUrl = docFlowApi.uploadFileUrl
    this.getProcessReceiverInfo()
    docFlowApi.getProcessPrefillInfo(this.item.dfProcessId, resp => {
      this.prevPrefillInfo = resp.data
    })
    docFlowApi.getChildProcessArchiveDoc(this.item.dfProcessId, resp => {
      this.childArchivedDocList = resp.data
    })
    docFlowApi.getArchiveDocType(resp => {
      this.archiveDocType = resp.data
    })
    if (this.item.securityLevelId && this.item.securityLevelId > 1) {
      await this.$store.dispatch(docFlowModule + '/getOpenerList', this.item.dfProcessId)
    } else {
      this.$store.commit(docFlowModule + '/setOpenerList', []) // clear the opener list
    }
  },
  methods: {
    closeProcess: function (processId) {
      let form = {
        dfProcessId: processId
      }
      docFlowApi.closeProcess(form, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.maskAsCompleteDialog = false
          this.getProcessList(false, this.filterText, this.docFlowStatus)
          // this.$store.dispatch(docFlowModule + '/getProcessList', [DOC_FLOW_STATUS.WAITING])
        }
      })
    },

    closeCardAndBack () {
      this.isShowSendToNextCard = false
      this.$emit('finish')
    },

    getProcessReceiverInfo () {
      docFlowApi.getProcessReceiverInfo(this.item.dfProcessId, resp => {
        this.receiverInfo = resp.data
      })
    },

    downloadArchiveFile (doc) {
      docFlowApi.downloadArchiveDocument(doc.docCode, this.item.dfProcessId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          // link.setAttribute('download', filename)
          link.setAttribute('download', doc.docName)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },

    prepareFileList (processId) {
      if (this.files && this.files.length && this.decryptedFileKey) {
        // console.log('prepareFileList: ' + this.decryptedFileKey)
        this.dialog = true
      } else {
        // console.log('this.files.length: ' + this.files.length + '  ' + this.decryptedFileKey)
        this.previewFileList(processId)
      }
    },

    showAndPrepareFileList () {
      if (this.isMeOpener && !this.decryptedFileKey) {
        this.previewFileList(this.item.dfProcessId, false) // find the encrypted document and get the "encryptedFileKey". Then set the key into store 'commonComponent' for decrypting file.
      }
      this.isShowSendToNextCard = true
    },

    momentWithHyphen
  }
}
</script>
